import * as Api from "api";
import {
  CREATE_DIVISION,
  DELETE_DIVISION,
  GET_DIVISIONS,
  GET_DIVISION_BY_ID,
  GET_PROGRAMS_BY_DIVISION,
  UPDATE_DIVISION,
} from "constants/divisions";
import { networkAction } from "helpers/network/networkAction";

export const getDivisions = () => async (dispatch) =>
  networkAction(dispatch, GET_DIVISIONS, Api.getDivisions, []);

export const getProgramsByDivision = (id) => async (dispatch) =>
  networkAction(dispatch, GET_PROGRAMS_BY_DIVISION, Api.getProgramsByDivision, [
    id,
  ]);

export const getDivisionById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_DIVISION_BY_ID, Api.getDivisionById, [id]);

export const deleteDivision = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_DIVISION, Api.deleteDivision, [id]);

export const createDivision = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_DIVISION, Api.createDivision, [body]);

export const updateDivision = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_DIVISION, Api.updateDivision, [id, body]);
